export default {
    // async getModList ({
    //     commit,
    //     state
    // }) {
    //     let data = JSON.parse(localStorage.getItem('modList')) || modList;
    //     console.log(data)
    //     commit('saveModList', data);
    //     // return res;
    // },
};
